<div class="template-view">
    <div class="heading">
        <div class="label">Preview Template</div>
        <mat-icon class="close-icon" (click)="cancel();">close</mat-icon>
    </div>
    <div mat-dialog-content>
        <app-template-details [templateDetails]="data?.templateDetails?.content"
            [templateType]="data?.templateDetails?.templateType | lowercase"
            [cardHeading]="data?.templateDetails?.cardHeading" [logo]="data?.logo" [showPreviewOnly]="true"
            [mobileNumber]="data?.mobileNumber" [companyName]="data?.companyName"
            [assessmentData]="data?.assessmentData">
        </app-template-details>
    </div>
    <div class="actions">
        <button mat-flat-button color="primary" class="edit-btn"
            *ngIf="!data?.hideActionBtns && !data?.templateDetails?.isDefault" (click)="editTemplate()">
            Edit
        </button>
        <!-- <button mat-flat-button 
            class="edit-btn" 
            *ngIf="data?.hideActionBtns" 
            (click)="cancel()">
            Close
        </button> -->
    </div>
</div>